import { render, staticRenderFns } from "./ProjectMngSystem.vue?vue&type=template&id=50f854c6&scoped=true"
import script from "./ProjectMngSystem.vue?vue&type=script&lang=js"
export * from "./ProjectMngSystem.vue?vue&type=script&lang=js"
import style0 from "./ProjectMngSystem.vue?vue&type=style&index=0&id=50f854c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f854c6",
  null
  
)

export default component.exports